/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { checkIfStoryPublic } from "../../../access-type-utils";
import { StoryElement } from "@quintype/components";
// import { RequestSubscription } from "../../pages/subscription-page/request-subscription";
import { Paywall } from "../../pages/subscription-page/paywall";
import { SectionName } from "../../atoms/section-tag";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import { HeroImage } from "../../atoms/hero-image";
import Loader from "../../atoms/loader";
// import assetify from "@quintype/framework/assetify";
import { Authors } from "../../atoms/author";
import { socialShareSupport } from "../../molecules/social-share";
import { isDesktopSizeViewport } from "../../../utils";
import { StoryCard } from "../../molecules/story-card";
import { StoryTags } from "../../atoms/social-tags";
import { SubscriptionCTA } from "../../molecules/subscription-cta";
import { CommentWidget } from "../../comment-widget";
import { AmazonPolly } from "../../molecules/amazon-polly/amazon-polly";
import { SaveButton } from "../../molecules/save-button";
import StopPress from "../../molecules/stop-press";
import { GiftStoryButton } from "../../molecules/gift-story-button";
// import LoadingIcon from "../../../../assets/images/loader.svg";
import { useUserSubscriptionData } from "../../../context/useUserSubscription";

import "./video-story.m.css";

const VideoStoryTemplate = props => {
  const { hasActiveSubscription } = useUserSubscriptionData();

  const [deviceWidth, deviceWidthHandler] = useState("");
  useEffect(() => {
    deviceWidthHandler(!isDesktopSizeViewport() ? "full-width" : "");
  }, []);

  const firstVideo =
    (props.story.cards &&
      props.story.cards
        .reduce((acc, element) => {
          acc = acc.concat(element["story-elements"]);
          return acc;
        }, [])
        .find(
          ({ type, subtype }) =>
            type === "youtube-video" ||
            (type === "jsembed" && subtype === "dailymotion-video") ||
            (type === "jsembed" && subtype === "facebook-video") ||
            (type === "jsembed" && subtype === "vimeo-video")
        )) ||
    {};

  const isStoryPublic = checkIfStoryPublic(props.story);
  const story = isStoryPublic
    ? props.story
    : hasActiveSubscription
    ? props.story
    : props.newStory;
  const storyCards = get(story, ["cards"], []);

  const HeaderVideo = props => {
    return (
      <div styleName="header-videos">
        <StoryElement element={firstVideo} key={firstVideo.id} story={story} />
      </div>
    );
  };
  function getStoryCards(cards = [], story, config, hasActiveSubscription) {
    return cards.map((card, index) => {
      const getSubscriptionCTA = get(
        card,
        ["metadata", "attributes", "subscriptioncta", 0],
        "No"
      );
      const getNewsletter = get(
        card,
        ["metadata", "attributes", "newsletter", 0],
        null
      );
      const getNewsletterStoryCard = () => {
        return getNewsletter ? (
          <div className="newsletter-grid">
            <StoryCard
              key={index}
              card={card}
              story={story}
              config={config}
              firstVideoElementID={firstVideoId}
            />
            <div className="story-card">
              <StopPress planName={getNewsletter} />
            </div>
          </div>
        ) : (
          <StoryCard
            key={index}
            card={card}
            story={story}
            config={config}
            firstVideoElementID={firstVideoId}
          />
        );
      };
      if (getSubscriptionCTA === "Yes") {
        return (
          <React.Fragment>
            {getNewsletterStoryCard()}
            {!hasActiveSubscription ? (
              <div className="story-card">
                <SubscriptionCTA url={story.slug} />{" "}
              </div>
            ) : null}
          </React.Fragment>
        );
      }
      return getNewsletterStoryCard();
    });
  }

  function showStoryCards(storyCards, config, story, hasActiveSubscription) {
    return (
      <>
        {getStoryCards(storyCards, story, config, hasActiveSubscription)}
        <div className="story-tags">
          <StoryTags story={story} />
        </div>
        {!hasActiveSubscription && checkIfStoryPublic(story) && (
          <div className="story-subscription">
            {<SubscriptionCTA url={story.slug} />}
          </div>
        )}
        <div className="metype-widget">
          <CommentWidget story={story} />
        </div>
      </>
    );
  }

  function getIfNoAccess(
    storyCards,
    config,
    story,
    hasActiveSubscription,
    member
  ) {
    const noOfVisibleCards = get(config, [
      "layout",
      "no-of-visible-cards-in-a-blocked-story"
    ]);
    console.log(member !== null && hasActiveSubscription === null);
    const eligibleCards = storyCards.slice(0, noOfVisibleCards);
    return (
      <>
        {getStoryCards(eligibleCards, story, config, hasActiveSubscription)}
        {member !== null && hasActiveSubscription === null ? (
          <div
            style={{
              display: "flex",
              height: "100px",
              flexDirection: "row",
              alignContent: "strech",
              justifyContent: "space-around"
            }}
          >
            <Loader color="#ec2227" />
          </div>
        ) : (
          <Paywall url={story.slug} {...props} />
        )}
      </>
    );
  }

  function getIfHasAccess(storyCards, config, story, hasActiveSubscription) {
    return showStoryCards(storyCards, config, story, hasActiveSubscription);
  }

  function handleAccess(
    storyCards,
    config,
    story,
    hasActiveSubscription,
    member
  ) {
    if (hasActiveSubscription) {
      return getIfHasAccess(storyCards, config, story, hasActiveSubscription);
    }
    return getIfNoAccess(
      storyCards,
      config,
      story,
      hasActiveSubscription,
      member
    );
  }

  const { id: firstVideoId = -1 } = firstVideo;

  const storyAccessLevel = get(story, ["access"], "");

  return (
    <div styleName="video-story-wrapper">
      <div className={`${deviceWidth}`}>
        {(props.member && hasActiveSubscription) || isStoryPublic?
        (
          <HeaderVideo story={story} />
        ) : (
          <HeroImage story={story} />
        )}
      </div>
      <div styleName="story-heading">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <Headline story={story} isStoryPage />
        <Subheadline story={story} />
        <div>
          {isStoryPublic || hasActiveSubscription ? (
            <AmazonPolly story={story} />
          ) : null}
        </div>
        <div>
          <Authors story={story} />
          <span style={{ verticalAlign: "middle" }}>
            &nbsp;&nbsp;&nbsp;
            <SaveButton story={story} />
          </span>
          {!isStoryPublic && hasActiveSubscription ? (
            <GiftStoryButton story={story} />
          ) : null}
        </div>
      </div>
      <div styleName="story-content">
        <div styleName="social-share-icons">
          <div styleName="sticky">{socialShareSupport(story)}</div>
        </div>
        <div styleName="story-cards">
          {isStoryPublic
            ? showStoryCards(
                storyCards,
                props.config,
                story,
                hasActiveSubscription
              )
            : handleAccess(
                storyCards,
                props.config,
                story,
                hasActiveSubscription,
                props.member
              )}
        </div>
      </div>
    </div>
  );
};

VideoStoryTemplate.propTypes = {
  story: PropTypes.shape({
    cards: PropTypes.array
  }),
  member: PropTypes.object,
  config: PropTypes.object,
  hasSubscription: PropTypes.bool
};

class VideoStoryAccessWrapper extends React.Component {
  render() {
    return (
      <div>
        {/* (this.props.member && this.props.hasSubscription=== null && !checkIfStoryPublic(this.props.story) )
        && <div styleName="modal">
              <div styleName="modal-content">
                <img src={assetify(LoadingIcon)} alt="loading" />
              </div>
    </div> */}
        <VideoStoryTemplate {...this.props} />
      </div>
    );
  }
}

class VideoStoryBase extends React.Component {
  render() {
    return <VideoStoryAccessWrapper {...this.props} />;
  }
}

VideoStoryBase.propTypes = {
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  member: get(state, ["member"], null),
  hasSubscription: get(state, ["isSubscribedUser", "userHasSubscription"], null)
});

export const VideoStory = connect(mapStateToProps)(VideoStoryBase);
